import type { User } from '@supabase/supabase-js';

/**
 * User의 app_metadata에서 TikTok 연동 여부 확인
 * DB 조회 없이 Session에서 바로 가져옴 (캐싱됨)
 *
 * @example
 * const user = useAuth(s => s.user);
 * const connected = getTikTokConnected(user);
 */
export function getTikTokConnected(user: User | null): boolean {
  if (!user) {
    return false;
  }
  return !!user.app_metadata?.tiktok;
}
